import $ from 'jquery';

const $iframeVideo = $('iframe[src*="youtube.com"]') || $('iframe[src*="vimeo.com"]');

const Video = {
    init() {
        if ($iframeVideo.length) this.responsiveVideoWrapping();
    },

    responsiveVideoWrapping() {
        $iframeVideo.wrap('<div class="embed-container"/>');
    },
};

export default Video;
